export default "__VITE_ASSET__d0690b4e__"